import { Table } from "reactstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_ALL_DEPARTMENT,
  GET_ALL_DESIGNATION,
  GET_ALL_KPI_BY_DEPARTMENT_ID,
  GET_ALL_USER,
} from "../../../../GraphQL/Queries";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import {
  DELETE_DEPARTMENT_BY_ID,
  DELETE_DEPARTMENT_KPI,
  DEPARTMENT_DELETED_STATUS_UPDATE,
} from "../../../../GraphQL/Mutation";
import { successMessage } from "../../../ReactToastify";
import { decryption } from "../../../HelperFunctions";
import Loader from "@/containers/Account/Profile/components/Loader";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import { Pagination } from "@mui/material";
import Swal from "sweetalert2";
const DeptListTable = () => {
  const [allDept, setAllDept] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const [deleteDeptId, setDeleteDeptId] = useState(null);
  const LoadAllDepartment = useQuery(GET_ALL_DEPARTMENT, {
    variables: {
      page: currentPage,
      size: limit,
    },
    fetchPolicy: "network-only",
  });
  const [deleteDepartmentById] = useMutation(DEPARTMENT_DELETED_STATUS_UPDATE);
  const UserList = useQuery(GET_ALL_USER);
  const DesigList = useQuery(GET_ALL_DESIGNATION);
  const [deleteToggle, setDeleteToggle] = useState(false);
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );

  const history = useHistory();
  const [modal, setModal] = useState(false);
  const id = history?.location?.state?.dept;
  const { data, loading, error, refetch } = useQuery(
    GET_ALL_KPI_BY_DEPARTMENT_ID,
    {
      variables: { dept_id: Number(id) },
      skip: !Number(id),
    }
  );
  const [deleteDepartmentkpi, { loading: deleteLoading }] = useMutation(
    DELETE_DEPARTMENT_KPI
  );

  const toggle = () => setModal((prev) => !prev);

  const deleteHandlerKpi = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the KPI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const { data } = await deleteDepartmentkpi({ variables: { id } });
        if (data?.deleteDepartmentkpi?.status === "Success") {
          toast.success("KPI deleted successfully");
          refetch?.(); // Optional: refetch KPI list
        } else {
          toast.error("KPI not found or could not be deleted");
        }
      } catch (err) {
        toast.error("Error deleting KPI");
        console.error(err);
      }
    } else {
      toast.info("Deletion cancelled");
    }
  };

  useEffect(() => {
    setAllDept(LoadAllDepartment?.data?.getAllDepartments?.data);
    LoadAllDepartment?.refetch();
  }, [LoadAllDepartment?.data?.getAllDepartments?.data, deleteToggle]);
  const deleteHandler = async (deptId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the KPI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const { data } = await deleteDepartmentById({
          variables: { id: deptId },
        });
        if (data?.departmentDeletedStatusUpdate?.result_code === "000") {
          toast.success("KPI deleted successfully");
          refetch?.();
        } else {
          console.log(
            "🚀 ~ deleteHandler ~ data?.deleteDepartmentById?.status:",
            data.departmentDeletedStatusUpdate.status
          );
          toast.error(
            `${
              data?.departmentDeletedStatusUpdate?.status || "Could not Delete"
            }`
          );
        }
      } catch (err) {
        toast.error(
          `${data?.departmentDeletedStatusUpdate?.status || "Could not Delete"}`
        );
        console.error(err);
      }
    } else {
      toast.info("Deletion cancelled");
    }

    // await deleteDepartmentById({
    //   variables: {
    //     id: deptId,
    //   },
    // });
    // successMessage("Delete successfully...", 1500);
    // setDeleteToggle((prevState) => !prevState);
  };
  const handleChange = (e, p) => {
    setCurrentPage(p);
    LoadAllDepartment.refetch({
      page: p,
    });
  };
  return (
    <>
      <Table role="table" striped hover responsive>
        <thead>
          <tr role="row">
            <th>#</th>
            <th>Name</th>
            <th>Head Of Department</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {LoadAllDepartment?.loading ? (
            <tr>
              <td colSpan="8" className="text-center">
                <SubmitLoading color="black" />
              </td>
            </tr>
          ) : (
            allDept?.map((item, index) => (
              <tr key={item?.id}>
                <th
                  onClick={() =>
                    history.push({
                      pathname: "/department/member",
                      state: {
                        deptID: item?.id,
                        deptName: item?.name,
                        data: item,
                      },
                    })
                  }
                >
                  {index + 1}
                </th>
                <td
                  // onClick={() =>
                  //   history.push({
                  //     pathname: "/department/member",
                  //     state: { deptID: item?.id, deptName: item?.name },
                  //   })
                  // }
                  onClick={() =>
                    history.push({
                      pathname: "/department/member",
                      state: {
                        deptID: item?.id,
                        deptName: item?.name,
                        data: item,
                      },
                    })
                  }
                >
                  {item?.name}
                </td>
                <td
                  onClick={() =>
                    history.push({
                      pathname: "/department/member",
                      state: {
                        deptID: item?.id,
                        deptName: item?.name,
                        data: item,
                      },
                    })
                  }
                  // onClick={() =>
                  //   history.push({
                  //     pathname: "/department/member",
                  //     state: { deptID: item?.id, deptName: item?.name },
                  //   })
                  // }
                >
                  {item?.user?.name} ({item?.user?.username})
                </td>
                <td
                  onClick={() =>
                    history.push({
                      pathname: "/department/member",
                      state: {
                        deptID: item?.id,
                        deptName: item?.name,
                        data: item,
                      },
                    })
                  }
                  // onClick={() =>
                  //   history.push({
                  //     pathname: "/department/member",
                  //     state: { deptID: item?.id, deptName: item?.name },
                  //   })
                  // }
                >
                  {item?.description?.split(" ").slice(0, 15).join(" ")}...
                </td>
                <td>
                  {permissions?.includes("delete_department") && (
                    <button
                      className="inbox__email-btn"
                      type="button"
                      aria-label="edit"
                      onClick={() => {
                        // setDeleteDeptId(item?.id);
                        deleteHandler(item?.id);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  )}
                  {permissions?.includes("update_department") && (
                    <button
                      className="inbox__email-btn mr-1"
                      type="button"
                      aria-label="edit"
                      onClick={() =>
                        history.push({
                          pathname: "/department/new",
                          state: {
                            dept: item,
                          },
                        })
                      }
                    >
                      <EditIcon fontSize="small" />
                    </button>
                  )}
                  {/* {permissions?.includes("update_department") && (
                  <Tooltip title="View KPI">
                    <button
                      className="inbox__email-btn mr-1"
                      type="button"
                      aria-label="view"
                      onClick={() =>
                        history.push({
                          // pathname: `/department/${item?.id}`,
                          pathname: "/department/kpi-list",
                          state: {
                            dept: item?.id,
                          },
                        })
                      }
                    >
                      <VisibilityIcon fontSize="small" />
                    </button>
                  </Tooltip>
                )} */}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      {LoadAllDepartment?.data?.getAllDepartments?.data?.length > 0 ? (
        <Pagination
          className="mt-2"
          count={
            LoadAllDepartment?.data?.getAllDepartments?.paginatorInfo?.lastPage
          }
          page={
            LoadAllDepartment?.data?.getAllDepartments?.paginatorInfo
              ?.currentPage
          }
          onChange={handleChange}
        />
      ) : null}
    </>
  );
};

export default DeptListTable;
